import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./user";
import systemReducer from "./system";

export default combineReducers({
  user: userReducer,
  system: systemReducer,
});
